<template>
    <b-container fluid>
        <page-title>
            <h2 v-if="item.correction==false"  >
                <router-link  :to="{ name: 'InvoiceList' }" class="nav-link">Faktury sprzedażowe</router-link>/Nowa faktura
            </h2>
            <h2 v-if="item.correction==true"  >
                <router-link  :to="{ name: 'InvoiceList' }" class="nav-link">Faktury sprzedażowe</router-link>/Korekta
             </h2>
            <div class="page-title__buttons"></div>
        </page-title>

        <div class="col page-element">
            <alert-loading v-if="loading || agreementRetrieveLoading || correctionRetrieveLoading"></alert-loading>
            <div v-if="error" class="alert alert-danger" role="alert">
                <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}
            </div>
            <div v-if="showMessageInvoiceAlreadyCreated" class="alert alert-danger" role="alert">
                <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                Faktura dla wybranej umowy została już wygenerowana
                <router-link :to="{name: 'InvoiceShow', params: { id: showMessageInvoiceAlreadyCreated}}" v-b-tooltip.hover.bottom title="Pokaż">
                Pokaż
                </router-link>
            </div>
            <div v-if="showMessageCorrectionAlreadyCreated" class="alert alert-danger" role="alert">
                <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                Korekta dla wybranej faktury została już wystawiona
                <router-link :to="{name: 'InvoiceShow', params: { id: showMessageCorrectionAlreadyCreated}}" v-b-tooltip.hover.bottom title="Pokaż">
                Pokaż
                </router-link>
            </div>

            <InvoiceForm  v-if="!loading && !agreementRetrieveLoading && !correctionRetrieveLoading " :handle-submit="handleSubmit" :values="item" :errors="violations"></InvoiceForm>
        </div>
    </b-container>
</template>

<script>
    import {mapGetters} from 'vuex'
    import InvoiceForm from './Form.vue'
    import moment from 'moment'
    import http from '../../utils/http'

    export default {
        components: {
            InvoiceForm
        },
        created(){
          this.$store.dispatch('invoice/create/reset');
          if(this.$route.query.agreement){
            this.$store.dispatch('agreement/update/reset')
            this.$store.dispatch('agreement/update/retrieve',this.$route.query.agreement)
          }

          if(this.$route.query.correction){
            this.$store.dispatch('invoice/correction/reset')
            this.$store.dispatch('invoice/correction/retrieve',this.$route.query.correction)
          }

        },
        data: function () {
            return {
                showMessageInvoiceAlreadyCreated: false,
                showMessageCorrectionAlreadyCreated: false,
                item: {
                    agreement: null,
                    customer: null,
                    customerData: {
                        name: '',
                        nip: '',
                        regon: '',
                        customerAddress: {
                            city: '',
                            number: '',
                            postalCode: '',
                            street: '',
                            country: ''
                        }
                    },
                    items: [
                        {amount: '', price: '', tax: 23, unit: 'usł.'}
                    ],
                    paymentDate: new Date(),
                    endDate: new Date(),
                    createDate: new Date(),
                }
            }
        },
        computed: {
        ...mapGetters({
          agreementRetrieveLoading: 'agreement/update/retrieveLoading',
          agreementRetrieved: 'agreement/update/retrieved',
          correctionRetrieved: 'invoice/correction/retrieved',
          correctionRetrieveLoading: 'invoice/correction/retrieveLoading',
          error: 'invoice/create/error',
          loading: 'invoice/create/loading',
          created: 'invoice/create/created',
          violations: 'invoice/create/violations',
          invoicePaymentType: 'config/config/invoicePaymentType'
        })},
        methods: {
            handleSubmit(item) {
              if(this.showMessageInvoiceAlreadyCreated === false && this.showMessageCorrectionAlreadyCreated === false){
                this.item = item
                this.$store.dispatch('invoice/create/create', item)
              }
            }
        },
        watch: {
          created: function (created) {
            if (created) {
              this.$router.push({ name: 'InvoiceShow', params: { id: created['id']} });
            }
          },
          agreementRetrieved: function (newData) {
            if(this.agreementRetrieveLoading){
              return;
            }
            if(newData.invoice != null){
              this.showMessageInvoiceAlreadyCreated = http.extractId(newData.invoice);
              return
            }

            this.item.currency = newData.currency['@id']
            this.item.agreement = newData['@id']
            this.item.paymentType = this.invoicePaymentType.find((item) => item.name == 'Kompensata')['@id']
            this.item.comments = 'Zapłata przez potrącenie.'
            this.item.paid = true

            if(newData.currency.foreign){
              var taxValue = ((newData.amount * newData.commission /100) * 0.23).toFixed(2);
              this.item.comments += ' VAT przeliczono po kursie średnim NBP z dnia  .......( Tabela nr ..........) ' + taxValue +' ' + newData.currency.name +' x ..... = .....'
            }
            this.item.customerData.name = newData.customerData.name
            this.item.customerData.nip = newData.customerData.nip
            this.item.customerData.regon = newData.customerData.regon
            this.item.customerData.customerAddress.city = newData.customerData.customerAddress.city
            this.item.customerData.customerAddress.number = newData.customerData.customerAddress.number
            this.item.customerData.customerAddress.postalCode = newData.customerData.customerAddress.postalCode
            this.item.customerData.customerAddress.street = newData.customerData.customerAddress.street
            this.item.customerData.customerAddress.country = newData.customerData.customerAddress.country
            this.item.items = [
               {
                 name: `Umowa faktoringowa nr ${newData.fullNumber} z dnia ${moment(newData.date).format('DD-MM-YYYY')}`,
                 amount: 1,
                 price: (newData.amount * newData.commission /100).toFixed(2),
                 tax: 23,
                 unit: 'szt.'
               }

            ]
          },
          correctionRetrieved: function (newData) {
//            if(newData.invoice != null){
//              this.showMessageCorrectionAlreadyCreated = http.extractId(newData.invoice);
//              return
//            }

            this.item.currency = newData.currency
            this.item.paymentType = newData.paymentType
            this.item.comments = newData.comments
            this.item.customerData.name = newData.customerData.name
            this.item.customerData.nip = newData.customerData.nip
            this.item.customerData.regon = newData.customerData.regon
            this.item.customerData.customerAddress.city = newData.customerData.customerAddress.city
            this.item.customerData.customerAddress.number = newData.customerData.customerAddress.number
            this.item.customerData.customerAddress.postalCode = newData.customerData.customerAddress.postalCode
            this.item.customerData.customerAddress.street = newData.customerData.customerAddress.street
            this.item.customerData.customerAddress.country = newData.customerData.customerAddress.country
            this.item.items = []
            this.item.correction = true
            this.item.correctedInvoice = {
              '@id': newData['@id'],
              fullNumber: newData.fullNumber,
              id: newData.id
            }
            this.item.correctedInvoiceItems = []
            for(let i = 0; i < newData.items.length; i++) {
              const value = newData.items[i];
              this.item.correctedInvoiceItems.push(
                {
                  name: value.name,
                  amount: value.amount,
                  price: value.price,
                  tax: value.tax,
                  taxName: value.taxName,
                  unit: value.unit,
                  taxType: value.taxType
                }
              )
              this.item.items.push(
                {
                  name: value.name,
                  amount: value.amount,
                  price: value.price,
                  tax: value.tax,
                  taxName: value.taxName,
                  unit: value.unit,
                  taxType: value.taxType
                }
              )
            }
          }
        },
        beforeDestroy() {
          if(this.$route.query.agreement){
            this.$store.dispatch('agreement/update/reset')
          }
        }

    }
</script>


// WEBPACK FOOTER //
// Create.vue?e6c109a2